import c from 'classnames';

import {
  INPUT_APPEARANCE_CLASSES,
  INPUT_DISABLED_CLASSES,
  INPUT_SHAPE_CLASSES,
} from '../Input/consts';
import { inputStyles } from '../Input/styles';
import { TypographyColors, TypographyVariants } from '../Typography/types';

interface GetTextareaClassesParams {
  color: TypographyColors;
  variant: TypographyVariants;
}

export const getTextareaClasses = ({ color, variant }: GetTextareaClassesParams) => ({
  disabled: c('pointer-events-none', INPUT_DISABLED_CLASSES.outline),
  input: c('pt-12 pb-36 px-16 h-auto self-stretch placeholder-text-placeholder', color, variant),
  root: c(
    'relative overflow-hidden p-0',
    inputStyles,
    INPUT_APPEARANCE_CLASSES.outline,
    INPUT_SHAPE_CLASSES.square,
  ),
});
